// ingredient-scanner.page.js
console.log('[ingredient-scanner] boot');

(async function () {
  // ==== CONFIG ====
  const ANALYTICS_ENDPOINT = '/analytics';

  // ---- load DB with fallback ----
  const SEED_DB = [
    { inci: "water", aliases: ["aqua"], status: "green", why: "Base solvent" },
    { inci: "glycerin", aliases: [], status: "green", why: "Humectant" },
    { inci: "phenoxyethanol", aliases: [], status: "green", why: "Preservative" },
    { inci: "fragrance", aliases: ["parfum"], status: "red", why: "Undisclosed mixture (mixture disclosure gap)" },
    { inci: "simmondsia chinensis seed oil", aliases: ["jojoba oil"], status: "green", why: "Emollient" },
    { inci: "helianthus annuus seed oil", aliases: ["sunflower seed oil"], status: "green", why: "Emollient" }
  ];
  let DB, lastModifiedHeader = '';
  try {
    const dbUrl = window.CHAMPAGNE_ING_DB_URL || 'https://cdn.shopify.com/s/files/1/0413/6973/1225/files/PATCHED_ingredient-db.v1.ethyst-patched.v4.reconciled.json?v=1759427247';
    const r = await fetch(dbUrl, { cache:'no-store' });
    if (!r.ok) throw new Error(r.statusText);
    lastModifiedHeader = r.headers.get('Last-Modified') || '';
    DB = await r.json();
  } catch (e) {
    console.warn('Using fallback seed DB:', e?.message || e);
    DB = SEED_DB;
  }

  // Credibility date label
  const $dbUpdated = document.getElementById('dbUpdated');
  let updatedLabel = 'Updated —';
  if ($dbUpdated) {
    const d = lastModifiedHeader ? new Date(lastModifiedHeader) : new Date();
    const fmt = d.toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: '2-digit' });
    $dbUpdated.textContent = `Updated ${fmt}`;
    updatedLabel = $dbUpdated.textContent;
  }

  // ---- runtime alias map ----
  const COMMON_ALIASES = new Map([
    // consumer/common oil names → INCI
    ["evening primrose oil", "oenothera biennis oil"],
    ["evening primrose", "oenothera biennis oil"],
    ["rosehip oil", "rosa canina fruit oil"],
    ["argan oil", "argania spinosa kernel oil"],
    ["marula oil", "sclerocarya birrea seed oil"],
    ["tamanu oil", "calophyllum inophyllum seed oil"],
    ["jojoba oil", "simmondsia chinensis seed oil"],
    ["sunflower seed oil", "helianthus annuus seed oil"],
    ["sweet almond oil", "prunus amygdalus dulcis oil"],
    ["olive oil", "olea europaea fruit oil"],
    ["grapeseed oil", "vitis vinifera seed oil"],
    ["pomegranate seed oil", "punica granatum seed oil"],
    ["cranberry seed oil", "vaccinium macrocarpon seed oil"],
    ["raspberry seed oil", "rubus idaeus seed oil"],
    ["blackcurrant seed oil", "ribes nigrum seed oil"],
    ["borage seed oil", "borago officinalis seed oil"],
    ["rubus idaeus raspberry seed oil", "rubus idaeus seed oil"],
    ["vaccinium macrocarpon cranberry seed oil", "vaccinium macrocarpon seed oil"],
    ["punica granatum pomegranate seed oil", "punica granatum seed oil"],

    // plant names seen as bare genus/species → canonical seed oil
    ["simmondsia chinensis", "simmondsia chinensis seed oil"],
    ["vitis vinifera", "vitis vinifera seed oil"],
    ["cannabis sativa", "cannabis sativa seed oil"],
    // explicit “cannabis sativa oil” → seed oil
    ["cannabis sativa oil", "cannabis sativa seed oil"],

    // surfactants / emollients & OCR variants
    ["caprylic/capric triglyceride", "caprylic/capric triglyceride"],
    ["caprylic capric triglyceride", "caprylic/capric triglyceride"], // slashless OCR variant
    ["capric triglyceride", "caprylic/capric triglyceride"],
    ["tricaprin", "caprylic/capric triglyceride"],
    ["tricaprylin", "caprylic/capric triglyceride"],
    // glued token when “(and)”/punctuation is stripped by OCR
    ["cetearyl olivate sorbitan olivate", "cetearyl olivate"],

    // common misspellings
    ["xantham gum", "xanthan gum"],

    // clays
    ["caolin clay", "kaolin"],
    ["kaolin clay", "kaolin"],
    ["china clay", "kaolin"]
  ].map(([k, v]) => [norm(k), v]));

  // ---- force-safe overrides (always Green, even if DB entry/alias missing) ----
  const FORCE_GREEN = new Set([
    // existing
    "decyl glucoside",
    "glycolic acid",
    "sunflower seed seed oil unsaponifiables",
    "cetearyl olivate",
    "sorbitan olivate",
    "cetearyl alcohol",
    "propanediol",
    "propylheptyl caprylate",
    "caprylic/capric triglyceride",
    "tocopheryl acetate",
    "cannabis sativa seed oil",
    "vitis vinifera seed oil",
    "rosa centifolia flower",
    "xanthan gum",
    "glycerin",
    "water",
    "sodium lactate",
    "beta-glucan",
    "niacinamide",
    "centella asiatica extract",
    "glycyrrhiza glabra root extract",
    "sodium pca",
    "sodium phytate",
    "panthenol",
    "aloe barbadensis leaf juice",
    "camellia sinensis leaf extract",
    "carthamus tinctorius seed oil"
  ].map(norm));

  const map = buildMap(DB);
  const allKeys = Array.from(map.keys());
  const sortedKeys = allKeys.slice().sort((a, b) => b.length - a.length);

  // ---- UI hooks ----
  const $input = document.getElementById("input");
  const $analyze = document.getElementById("analyze");
  const $upload = document.getElementById("fileInput");
  const $camera = document.getElementById("cameraInput");
  const $preview = document.getElementById("preview");
  const $progress = document.getElementById("progress");
  const $quickFind = document.getElementById("quickFind");

  const $resultsGrid = document.getElementById("results");
  const $resultsEmpty = document.getElementById("results-empty");

  const $btnMethodology = document.getElementById('btnMethodology');
  const $modalMethodology = document.getElementById('modalMethodology');
  const $btnAlternatives = document.getElementById('btnAlternatives');
  const $btnShare = document.getElementById('btnShare');
  const $btnLink = document.getElementById('btnLink');
  const $demoBtn = document.getElementById('demoBtn');

  // Score headline
  const $scoreBar = document.getElementById('scoreBar');
  const $scoreVal = document.getElementById('scoreVal');
  const $scoreCounts = document.getElementById('scoreCounts');

  const MAX_PILLS_SHOWN = 20;

  console.log('[ingredient-scanner] DOM ready');

  // === Why popover ===
  injectWhyStyles();
  const popover = createWhyPopover();

  // ===== Progress banner handling (silent) =====
  function setProgress(msg) {
    if ($progress) $progress.textContent = msg || "";
  }
  $input?.addEventListener('input', () => {
    if ($preview?.getAttribute('src')) $preview.removeAttribute('src');
    setProgress('');
    updateSharableUrl();
  });

  // Analyze click / kbd
  $analyze?.addEventListener("click", () => runAnalysis('click'));
  $input?.addEventListener("keydown", (e) => {
    if ((e.ctrlKey || e.metaKey) && e.key === "Enter") runAnalysis('kbd');
  });

  // Demo chip
  $demoBtn?.addEventListener('click', () => {
    const demo = "Water (Aqua), Glycerin, Sodium Laureth Sulfate, Fragrance (Parfum), Phenoxyethanol, Simmondsia Chinensis (Jojoba) Seed Oil";
    if ($input) $input.value = demo;
    runAnalysis('demo');
    window.scrollTo({ top: $scoreBar?.offsetTop || 0, behavior: 'smooth' });
  });

  // Upload / Camera
  $upload?.addEventListener("change", (e) => handleFile(e.target.files?.[0]));
  $camera?.addEventListener("change", (e) => handleFile(e.target.files?.[0]));

  // Shareable link
  $btnLink?.addEventListener('click', async () => {
    const url = updateSharableUrl();
    try {
      await navigator.clipboard.writeText(url);
      alert("Copied link to clipboard:\n\n" + url);
      sendEvent('cta_copy_link', {});
    } catch {
      prompt("Copy this link:", url);
    }
  });

  // Print/PDF
  $btnShare?.addEventListener('click', () => {
    window.print();
    sendEvent('cta_share_report', {});
  });

  // ---- OCR pipeline ----
  async function handleFile(file) {
    if (!file) return;
    if ($preview) $preview.src = URL.createObjectURL(file);

    try {
      const img = await loadImage($preview?.src);
      const { canvas } = downscale(img, 1600, 1600);
      if (!window.Tesseract) return;

      const { data } = await Tesseract.recognize(canvas, "eng", { logger: () => {} });
      const raw = data?.text || "";
      if ($input) $input.value = raw;
      runAnalysis('ocr', raw);
      setProgress('');
      sendEvent('ocr_done', { chars: raw.length });
    } catch (err) {
      console.error(err);
      setProgress('');
      sendEvent('ocr_error', { msg: String(err) });
    }
  }

  // Main analysis
  function runAnalysis(mode = 'click', rawText = null) {
    // 🚫 flush old ghost unknowns
    localStorage.removeItem('scanner_unknowns');

    const source = rawText ?? $input?.value ?? '';
    const res = classify(tokenize(source), map, sortedKeys);
    renderResults(res, { mode });
    updateSharableUrl();
  }


  // Shareable URL
  function updateSharableUrl() {
    const val = encodeURIComponent($input?.value || '');
    const url = `${location.origin}${location.pathname}?q=${val}`;
    history.replaceState(null, '', url);
    return url;
  }

  // On load, hydrate from ?q=
  (function bootstrapFromQuery(){
    const params = new URLSearchParams(location.search);
    const q = params.get('q');
    if (q) {
      const text = q;
      if ($input) $input.value = text;
      runAnalysis('deep-link', text);
      window.scrollTo({ top: $scoreBar?.offsetTop || 0, behavior: 'smooth' });
    }
  })();

  // ---- helpers ----
  function loadImage(src) {
    return new Promise((res, rej) => {
      const i = new Image();
      i.onload = () => res(i);
      i.onerror = rej;
      i.src = src;
    });
  }

  function downscale(img, maxW, maxH) {
    const ratio = Math.min(maxW / img.width, maxH / img.height, 1);
    const w = Math.round(img.width * ratio), h = Math.round(img.height * ratio);
    const c = document.createElement("canvas"); c.width = w; c.height = h;
    c.getContext("2d").drawImage(img, 0, 0, w, h);
    return { canvas: c, w, h };
  }

  // ===== DB → MAP builder =====
  function buildMap(rows) {
    const m = new Map();
    if (!Array.isArray(rows)) {
      console.warn('DB is not an array — using empty set');
      return m;
    }
    for (const r of rows) {
      if (typeof r === 'string') {
        const inciStr = r.trim();
        if (inciStr) {
          const payload = { inci: inciStr, status: 'unknown', why: '' };
          m.set(norm(inciStr), payload);
        }
        continue;
      }
      if (r && typeof r === 'object' && typeof r.inci === 'string' && r.inci.trim()) {
        const inci = r.inci.trim();
        const status = String(r.status || 'unknown').toLowerCase();
        const payload = { inci, status, why: (r.why || '') };

        m.set(norm(inci), payload);
        const aliases = Array.isArray(r.aliases) ? r.aliases : [];
        for (const a of aliases) {
          if (typeof a === 'string' && a.trim()) {
            m.set(norm(a), payload);
          }
        }
      }
    }
    console.info('Ingredient DB loaded:', { uniqueKeys: m.size });
    return m;
  }

  function norm(s) {
    return (s || '').toLowerCase()
      .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      .replace(/[^\w\s\-]/g, ' ')
      .replace(/\s+/g, ' ').trim();
  }

  // ---------- canonicalization helpers ----------
  const PLANT_TAILS = [
    "seed oil", "fruit oil", "kernel oil", "oil",
    "leaf extract", "root extract", "flower extract",
    "bark extract", "stem extract", "flower/leaf/vine extract",
    "extract", "seed oil unsaponifiables", "unsaponifiables", "sterols"
  ];

  function canonicalizePlantPhrase(token) {
    if (!/^[a-z]+ [a-z]+/.test(token)) return token;
    let bestTail = "";
    for (const t of PLANT_TAILS) if (token.endsWith(t) && t.length > bestTail.length) bestTail = t;
    if (!bestTail) return token;
    const parts = token.split(/\s+/);
    const genus = parts[0], species = parts[1];
    if (!/^[a-z]+$/.test(genus) || !/^[a-z]+$/.test(species)) return token;
    return `${genus} ${species} ${bestTail}`;
  }

  function canonicalizeTails(token) {
    token = token.replace(/\s+/g, ' ').trim();
    token = token.replace(/\bseed oil unsaponifiables\b/g, "seed oil unsaponifiables");
    if (/unsaponifiables$/.test(token) && /\bseed oil\b/.test(token)) {
      token = token.replace(/\bunsaponifiables\b/g, '').replace(/\s+/g, ' ').trim() + " unsaponifiables";
    }
    return token;
  }
  // ----------------------------------------------

  // tokenizer
  function tokenize(text) {
    const cleaned = (text || '')
      .replace(/\([^)]*\)/g, ' ')
      .replace(/ingredients?:/ig, ' ')
      .replace(/may contain.*$/ig, ' ')
      .replace(/[•\u2022\u00B7]/g, ',');
    return cleaned
      .split(/[;,]+/g)
      .map(s => s.trim())
      .filter(Boolean)
      .map(s => norm(s))
      .map(s => canonicalizePlantPhrase(s))
      .map(s => canonicalizeTails(s))
      .filter(s => s.length > 1);
  }

  // classify
  function classify(tokens, map, keys) {
    const seenTokens = new Set();
    const seenCanonical = new Set();
    const buckets = { green: [], yellow: [], red: [], unknown: [] };

    for (const rawT of tokens) {
      if (seenTokens.has(rawT)) continue;
      seenTokens.add(rawT);

      const t = norm(COMMON_ALIASES.get(norm(rawT)) || rawT);
      let hit = map.get(t);

      if (!hit && t.length >= 4) {
        for (const k of keys) {
          if (k.length < 4) break;
          if (t.includes(k) || k.includes(t)) { hit = map.get(k); if (hit) break; }
          const collapsed = canonicalizePlantPhrase(t);
          if (collapsed !== t) { const h2 = map.get(collapsed); if (h2) { hit = h2; break; } }
        }
      }

      // ----- policy override: FORCE_GREEN -----
      const canonicalKey = norm(hit?.inci || t);
      if (FORCE_GREEN.has(canonicalKey)) {
        const inciName = hit?.inci || rawT;
        if (!seenCanonical.has(inciName)) {
          seenCanonical.add(inciName);
          buckets.green.push({ inci: inciName, status: 'green', why: 'Policy: forced safe' });
        }
        continue; // skip further processing
      }
      // ---------------------------------------

      if (hit) {
        const st = String(hit.status || 'unknown').toLowerCase();
        if (!seenCanonical.has(hit.inci)) {
          seenCanonical.add(hit.inci);
          buckets[st]?.push({ ...hit, status: st });
        }
      } else {
        if (!seenCanonical.has(t)) {
          seenCanonical.add(t);
          buckets.unknown.push({ inci: t, status: 'unknown', why: '' });
        }
      }
    }

    const u = buckets.unknown.map(x => x.inci);
    if (u.length) {
      const prev = JSON.parse(localStorage.getItem('scanner_unknowns') || '[]');
      localStorage.setItem('scanner_unknowns', JSON.stringify(prev.concat(u)));
    }
    return buckets;
  }

  // Score calc
  function computeScore(b) {
    const reds = b.red.length || 0;
    const yellows = b.yellow.length || 0;
    const greens = b.green.length || 0;
    let s = 100 - (25 * reds) - (8 * yellows) + (2 * Math.min(greens, 10));
    return Math.max(0, Math.min(100, Math.round(s)));
  }

  function renderScore(b) {
    const total = b.green.length + b.yellow.length + b.red.length + b.unknown.length;
    if (!total) { hideScore(); return; }

    const score = computeScore(b);

    if ($scoreVal) $scoreVal.textContent = String(score);
    if ($scoreCounts) $scoreCounts.textContent = `• ${b.red.length} Avoid • ${b.yellow.length} Caution • ${b.green.length} Safe`;

    if ($scoreBar) {
      $scoreBar.hidden = false;
      $scoreBar.classList.toggle('elite', b.red.length === 0 && score >= 95);
    }

    if ($btnAlternatives) $btnAlternatives.hidden = !(b.red.length || b.yellow.length);
  }

  function hideScore() {
    if ($scoreBar) { $scoreBar.hidden = true; $scoreBar.classList.remove('elite'); }
    if ($scoreVal) $scoreVal.textContent = '—';
    if ($scoreCounts) $scoreCounts.textContent = '';
    if ($btnAlternatives) $btnAlternatives.hidden = true;
  }

  function clearAllBuckets() {
    ['green', 'yellow', 'red', 'unknown'].forEach(k => {
      const slot = document.getElementById(`list-${k}`);
      const empty = document.getElementById(`empty-${k}`);
      const count = document.getElementById(`count-${k}`);
      const more = document.getElementById(`more-${k}`);
      slot && (slot.innerHTML = '');
      empty && (empty.hidden = true);
      count && (count.textContent = '0');
      more && (more.hidden = true);
    });
  }

  function maybeToggleEmpty(isEmpty) {
    if ($resultsGrid && $resultsEmpty) {
      if (isEmpty) { $resultsGrid.hidden = true; $resultsEmpty.hidden = false; }
      else { $resultsGrid.hidden = false; $resultsEmpty.hidden = true; }
    }
  }

  function renderResults(b, opts = {}) {
    const totalCount = ['green', 'yellow', 'red', 'unknown']
      .reduce((n, k) => n + (b[k]?.length || 0), 0);

    if (!totalCount) {
      clearAllBuckets();
      maybeToggleEmpty(true);
      hideScore();
      return;
    }
    maybeToggleEmpty(false);
    renderScore(b);

    const ORDER = ['red', 'yellow', 'green', 'unknown'];

    for (const k of ORDER) {
      const items = b[k] || [];
      const slot = document.getElementById(`list-${k}`);
      const empty = document.getElementById(`empty-${k}`);
      const count = document.getElementById(`count-${k}`);
      const more = document.getElementById(`more-${k}`);

      if (!slot) continue;
      slot.innerHTML = '';

      count && (count.textContent = String(items.length));

      if (!items.length) {
        empty && (empty.hidden = false);
        more && (more.hidden = true);
        continue;
      } else {
        empty && (empty.hidden = true);
      }

      const visible = items.slice(0, MAX_PILLS_SHOWN);
      visible.forEach(item => slot.appendChild(pill(item)));

      if (items.length > MAX_PILLS_SHOWN && more) {
        more.hidden = false;
        more.textContent = `Show all (${items.length})`;
        more.onclick = () => {
          slot.innerHTML = '';
          items.forEach(item => slot.appendChild(pill(item)));
          more.hidden = true;
        };
      } else if (more) {
        more.hidden = true;
      }
    }

    sendEvent('classified', {
      mode: opts.mode || 'analyze',
      green: b.green.length, yellow: b.yellow.length, red: b.red.length, unknown: b.unknown.length
    });

    lastResults = b;
  }

  // pill
  function pill(item) {
    const span = document.createElement('span');
    span.className = `pill ${item.status}`;
    span.dataset.inci = item.inci;
    span.dataset.status = item.status;

    const strong = document.createElement('strong');
    strong.textContent = item.inci;
    span.appendChild(strong);
    return span;
  }

  // Collapsible buckets
  document.querySelectorAll('.toggle[data-toggle]').forEach(btn => {
    btn.addEventListener('click', () => {
      const key = btn.getAttribute('data-toggle');
      const bucket = document.querySelector(`.bucket[data-bucket="${key}"]`);
      if (!bucket) return;
      const items = bucket.querySelector('.bucket__items');
      const empty = bucket.querySelector('.empty');
      const expanded = btn.getAttribute('aria-expanded') !== 'false';
      if (expanded) {
        items && (items.style.display = 'none');
        empty && (empty.style.display = 'none');
        btn.textContent = 'Expand list';
        btn.setAttribute('aria-expanded', 'false');
      } else {
        items && (items.style.display = '');
        empty && (empty.style.display = '');
        btn.textContent = 'Collapse list';
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });

  // Methodology modal
  $btnMethodology?.addEventListener('click', () => {
    $modalMethodology?.setAttribute('open', '');
  });
  $modalMethodology?.addEventListener('click', (e) => {
    if (e.target === $modalMethodology || e.target.hasAttribute('data-close')) {
      $modalMethodology.close?.();
      $modalMethodology.removeAttribute('open');
    }
  });

  // ==== Outcome CTAs ====
  let lastResults = { green: [], yellow: [], red: [], unknown: [] };

  // Why popover helpers (minimal)
  function injectWhyStyles() {
    const css = `
    #why-popover{position:fixed;z-index:1000;max-width:420px;background:#fff;border:1px solid var(--line,#e6e6e8);border-radius:12px;box-shadow:0 12px 28px rgba(0,0,0,.18);padding:14px}
    #why-popover[hidden]{display:none}
    `;
    const el = document.createElement('style');
    el.textContent = css;
    document.head.appendChild(el);
  }
  function createWhyPopover() {
    const div = document.createElement('div');
    div.id = 'why-popover';
    div.hidden = true;
    document.body.appendChild(div);
    return div;
  }
  function hideWhyPopover() { popover.hidden = true; }

  // ---- Observability ----
  function sendEvent(type, data) {
    try {
      const payload = JSON.stringify({ type, data, ts: Date.now(), ua: navigator.userAgent });
      if (navigator.sendBeacon) {
        navigator.sendBeacon(ANALYTICS_ENDPOINT, new Blob([payload], { type: 'application/json' }));
      } else {
        fetch(ANALYTICS_ENDPOINT, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: payload }).catch(() => { });
      }
    } catch (e) { /* noop */ }
  }

  // quick debugger
  window.DEBUG_FIND = (s) => {
    const toks = tokenize(s);
    return { toks, res: classify(toks, map, sortedKeys) };
  };
})();
